import React, { Fragment } from "react";
import { Row, Icon } from "../components";
import { useI18n } from "../lib/i18n/i18n_provider";
import { Spacer } from "./spacer";
import { Text } from "./text";
import "./template_testimonial.css";
import { TextLink } from "./text_link";
import { Testimonial } from "../data/partners";

export function TemplateTestimonial(testimonial: Testimonial) {
  const { fbt } = useI18n();

  return (
    <Fragment>
      {testimonial.avatar && (
        <img
          className="testimonial-card-avatar"
          style={{
            width: 80,
            height: 80,
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translate(-50%, -50%)",
            borderRadius: "50%",
            objectFit: "cover",
          }}
          alt="testimonial user avatar"
          src={testimonial.avatar}
        />
      )}
      <div
        className="testimonial-card"
        style={{
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          marginTop: testimonial.avatar ? 25 : 8,
          border: "1px solid #F0F0F0",
          backgroundColor: "white",
          padding: 16,
          paddingTop: 30,
          height: "inherit",
        }}
      >
        {/* TODO: this assumption is made according to the current use-cases. Update it if needed. */}
        {!testimonial.avatar && !testimonial.showQuoteIcon && (
          <Row justifyContent="center">
            {Array(testimonial.stars || 5)
              .fill(1)
              .map(() => (
                <Icon name="star" />
              ))}
          </Row>
        )}
        {!testimonial.showQuoteIcon && <Spacer size={16} />}
        {!!testimonial.showQuoteIcon && (
          <img
            alt="quotes"
            src="https://meet-production.s3.us-west-1.amazonaws.com/icons/offerings/quote.png"
            style={{ width: 32 }}
          />
        )}
        <Text align="center" size="md">
          {testimonial.testimonial}
        </Text>
        <Spacer />
        <Spacer size={16} />
        <Text align="center" size="md" weight="bold">
          {testimonial.name}
        </Text>
        <Text size="md" align="center">
          {testimonial.companyTitle ||
            (!!testimonial.reviewLink && !!testimonial.reviewLinkText && (
              <Fragment>
                Review from{" "}
                <TextLink
                  color="default"
                  external
                  href={testimonial.reviewLink}
                >
                  {testimonial.reviewLinkText}
                </TextLink>
              </Fragment>
            )) ||
            fbt("Review from Google")}
        </Text>
        {!!testimonial.companyLogo && (
          <span
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <img
              style={{
                maxWidth: 80,
                width: "100%",
                maxHeight: 56,
                height: "100%",
              }}
              alt="testimonial company logo"
              src={testimonial.companyLogo}
            />
          </span>
        )}
      </div>
    </Fragment>
  );
}
